import { api } from '@/modules/shared/lib/axios'
import type { ResponseAPI } from '@/modules/shared/types/response-api.type'

export type OrderFormJsonViewService = {
  payload: {
    orderId: string | number
    userId: string | number
    dispositivoId?: string | number
  }
}

export const orderFormJsonViewService = async ({
  payload,
}: OrderFormJsonViewService): Promise<ResponseAPI> => {
  const response = await api.get(
    `carregapedido/${payload.userId}/${payload.dispositivoId}/${payload.orderId}`,
  )

  return response.data
}
